import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RestaurantRawMaterialCategoryDTO } from '../../../types/restaurant/RestaurantRawMaterialCategoryTypes';
import {
  RawMaterialSupplierOption,
  RawMaterialUnitOption,
  RestaurantRawMaterialDTO,
  RestaurantRawMaterialForm,
  RestaurantRawMaterialPage,
} from '../../../types/restaurant/RestaurantRawMaterialTypes';

export const emptyRawMaterialForm: RestaurantRawMaterialForm = {
  categoryId: '',
  unitId: '',
  supplierId: '',
  code: '',
  name: '',
  description: '',
  minimumStock: 0,
  currentStock: 0,
  cost: 0,
  barcode: '',
};

interface State {
  list: RestaurantRawMaterialDTO[];
  page: RestaurantRawMaterialPage | null;
  categories: RestaurantRawMaterialCategoryDTO[];
  units: RawMaterialUnitOption[];
  suppliers: RawMaterialSupplierOption[];
  form: RestaurantRawMaterialForm;
  loading: boolean;
  saving: boolean;
  modalOpen: boolean;
}

const initialState: State = {
  list: [],
  page: null,
  categories: [],
  units: [],
  suppliers: [],
  form: emptyRawMaterialForm,
  loading: false,
  saving: false,
  modalOpen: false,
};

const slice = createSlice({
  name: 'restaurantRawMaterial',
  initialState,
  reducers: {
    setRawMaterialPage: (
      state,
      action: PayloadAction<RestaurantRawMaterialPage | null>
    ) => {
      state.page = action.payload;
      state.list = action.payload?.content ?? [];
    },
    setRawMaterialOptions: (
      state,
      action: PayloadAction<{
        categories: RestaurantRawMaterialCategoryDTO[];
        units: RawMaterialUnitOption[];
        suppliers: RawMaterialSupplierOption[];
      }>
    ) => {
      Object.assign(state, action.payload);
    },
    setRawMaterialLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setRawMaterialSaving: (state, action: PayloadAction<boolean>) => {
      state.saving = action.payload;
    },
    openRawMaterialCreate: (state) => {
      state.form = { ...emptyRawMaterialForm };
      state.modalOpen = true;
    },
    openRawMaterialEdit: (
      state,
      action: PayloadAction<RestaurantRawMaterialDTO>
    ) => {
      const item = action.payload;
      state.form = {
        id: item.id,
        categoryId: item.categoryId,
        unitId: item.unitId,
        supplierId: item.supplierId ?? '',
        code: item.code,
        name: item.name,
        description: item.description ?? '',
        minimumStock: item.minimumStock ?? '',
        currentStock: item.currentStock ?? '',
        cost: item.cost ?? '',
        barcode: item.barcode ?? '',
        active: item.active,
      };
      state.modalOpen = true;
    },
    closeRawMaterial: (state) => {
      state.form = { ...emptyRawMaterialForm };
      state.modalOpen = false;
    },
    updateRawMaterialField: (
      state,
      action: PayloadAction<{
        field: keyof RestaurantRawMaterialForm;
        value: RestaurantRawMaterialForm[keyof RestaurantRawMaterialForm];
      }>
    ) => {
      state.form = {
        ...state.form,
        [action.payload.field]: action.payload.value,
      };
    },
  },
});

export const {
  setRawMaterialPage,
  setRawMaterialOptions,
  setRawMaterialLoading,
  setRawMaterialSaving,
  openRawMaterialCreate,
  openRawMaterialEdit,
  closeRawMaterial,
  updateRawMaterialField,
} = slice.actions;
export default slice.reducer;
